import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';
import achievementEnumerators from 'src/modules/achievement/achievementEnumerators';

export default [
  {
    name: 'id',
    label: i18n('entities.achievement.fields.id'),
  },
  {
    name: 'title',
    label: i18n('entities.achievement.fields.title'),
  },
  {
    name: 'description',
    label: i18n('entities.achievement.fields.description'),
  },
  {
    name: 'type',
    label: i18n('entities.achievement.fields.type'),
    render: (value) => achievementEnumerators.type[value],
  },
  {
    name: 'goal',
    label: i18n('entities.achievement.fields.goal'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.achievement.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.achievement.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
]; 